import GameInterface from "../Interfaces/GameInterface";

export default class BaseMap
{
    game: GameInterface;

    boot()
    {
        //
    }

    setGame(game: GameInterface): void
    {
        this.game = game;
    }
}
